import { extent, range, ascending, rollup } from "d3-array";

function getItems(poems) {
  const itemsMap = new Map();

  const yearsExtent = extent(poems, d => d.year);
  const allConsecutiveYears = range(yearsExtent[0], yearsExtent[1] + 1);

  const poemsCountPerYear = rollup(
    poems,
    v => v.length,
    d => d.year
  );

  function addItem(type, value, key) {
    itemsMap.set(key, {
      type,
      value,
      key,
      values: allConsecutiveYears.map(year => ({
        year,
        countWithDuplicates: 0,
        countWithoutDuplicates: 0
      }))
    });
  }

  function getItemKey(value, type) {
    return `${value} (${type})`;
  }

  function countItem(d, type) {
    d[`${type}s`].forEach((v, i) => {
      const value = v;
      const key = getItemKey(value, type);
      if (!itemsMap.has(key)) {
        addItem(type, value, key);
      }
      const item = itemsMap.get(key).values.find(e => e.year === d.year);
      item.countWithDuplicates++;
      if (d[`${type}s`].indexOf(v) === i) item.countWithoutDuplicates++;
    });
  }

  poems.forEach(d => {
    countItem(d, "theme");
    countItem(d, "mood");
    countItem(d, "motif");
  });

  const orderedTypes = ["theme", "mood", "motif"];

  const items = [...itemsMap.values()].sort((a, b) => {
    if (a.type !== b.type) {
      return ascending(
        orderedTypes.indexOf(a.type),
        orderedTypes.indexOf(b.type)
      );
    } else {
      return ascending(a.value, b.value);
    }
  });

  items.forEach(d => {
    d.values.forEach(v => {
      const poemsCountThatYear = poemsCountPerYear.get(v.year);
      v.percentageYear = poemsCountThatYear
        ? v.countWithoutDuplicates / poemsCountThatYear
        : 0;
      v.percentageTotal = v.countWithoutDuplicates / poems.length;
    });
    Object.freeze(d.values);
  });
  return items;
}

export { getItems };
